module.exports = __webpack_public_path__ + "img/2000-WEB.566dc3b5.jpg";